import React, { Component } from 'react';
import AddQueue from '../assets/icons/add.svg';
import QueueData from './QueueData';
import Modal from '../CommonComponents/Modal';
import QueueCreation from './QueueCreation';
import { api } from '../utils';

type Props = { selectedBotid: string; toasterNotify: Function; tenantId: number };

type State = { createQueueModalOpen: boolean; latestQueueName: string; count: number };

export default class QueuesTab extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = this.setInitialState();
    this.createQueue = this.createQueue.bind(this);
    this.setInitialQueueName = this.setInitialQueueName.bind(this);
    this.closeQueueCreationModal = this.closeQueueCreationModal.bind(this);
  }
  setInitialState(): State {
    return { createQueueModalOpen: false, latestQueueName: '', count: 0 };
  }
  createQueue() {
    this.setState({
      createQueueModalOpen: true,
    });
  }
  setInitialQueueName(val: string) {
    this.setState({
      latestQueueName: val,
    });
    localStorage.setItem('latestQueueNameEdited', this.state.latestQueueName);
  }
  closeQueueCreationModal() {
    this.setState({
      createQueueModalOpen: !this.state.createQueueModalOpen,
      count: this.state.count + 1,
    });
  }
  render() {
    return (
      <div
        style={{ overflowY: 'auto', height: 'calc(100vh - 193px)', overflowX: 'hidden' }}>
        <div className='queues-header'>
          <div className='queues'>Queues</div>
          <div
            className='create-queue'
            onClick={this.createQueue}
            style={{ marginRight: '-17px' }}>
            <img src={AddQueue} alt='add queue' />
            Create queue
          </div>
        </div>
        <QueueData
          botid={this.props.selectedBotid}
          setInitialQueueName={this.setInitialQueueName}
          count={this.state.count}
          toasterNotification={this.props.toasterNotify}
          tenantId={this.props.tenantId}
        />
        {/* changed */}
        {this.state.createQueueModalOpen ? (
          <Modal
            isOpen={this.state.createQueueModalOpen}
            title={this.state.latestQueueName}
            onClose={() => {
              this.setState(
                {
                  createQueueModalOpen: !this.state.createQueueModalOpen,
                },
                () => {
                  let encodedbotId = encodeURIComponent(this.props.selectedBotid);
                  api(`getQueueList?botId=${encodedbotId}`).then((res) => {
                    this.setState({
                      latestQueueName: res.defaultQueueName,
                    });
                  });
                }
              );
            }}
            source='queue-creation'
            handleClick={(val: string) => {
              this.setState({
                latestQueueName: val,
              });
            }}
            onFocusFieldChange={(latestQueueName) => this.setState({ latestQueueName })}>
            <QueueCreation
              selectedBotId={this.props.selectedBotid}
              closeCreateQueue={this.closeQueueCreationModal}
              notification={this.props.toasterNotify}
              action={this.state.createQueueModalOpen ? 'add' : ''}
              queueName={this.state.latestQueueName}
              tenantId={this.props.tenantId}
            />
          </Modal>
        ) : null}
      </div>
    );
  }
}
